import React, { Component } from 'react'
import { compose, mapProps, branch, renderComponent } from 'recompose'
import cx from 'classnames'
import IconSVG from 'svg-inline-react'
import { Link } from 'react-router'

import ACCESS from 'utils/Access'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'

import { Icon } from '@driftt/tide-core-legacy'
import EndUserAvatar from "./EndUserAvatar"
import FollowButton from "./FollowButton"
import LocalTime from "./LocalTime"
import Placeholder from "./Placeholder"
import EnrollButtonConvo from "./EnrollButtonConvo"

import * as style from './style.styl'

import twitterIconSrc from '!svg-inline?removeTags=true!images/icons/twitter-logo.svg'
import linkedinIconSrc from '!svg-inline?removeTags=true!images/icons/linkedin.svg'

const TwitterHandle = ({ twitterHandle }) => {
  return (
    <a href={`https://twitter.com/${twitterHandle}`} target="_blank">
      <IconSVG className="social-icon" src={twitterIconSrc} />
    </a>
  )
}

const LinkedInHandle = ({ linkedInHandle }) => {
  return (
    <a href={`https://www.linkedin.com/${linkedInHandle}`} target="_blank">
      <IconSVG className="social-icon social-icon-linkedin" src={linkedinIconSrc} />
    </a>
  )
}

const Loading = () => {
  return (
    <div className={cx(style.profile, 'placeholder')}>
      <Placeholder />
    </div>
  )
}

class Profile extends Component {
  renderSocialIcons() {
    const { twitterHandle, linkedInHandle } = this.props

    if (!twitterHandle && !linkedInHandle) {
      return null
    }

    return (
      <span className="social-icons">
        {twitterHandle && <TwitterHandle twitterHandle={twitterHandle} />}
        {linkedInHandle && <LinkedInHandle linkedInHandle={linkedInHandle} />}
      </span>
    )
  }

  renderEmail() {
    const {
      email,
      displayName,
    } = this.props

    if (!email || (email === displayName)) {
      return null
    }

    return (
      <div className="flex-row icon-row">
        <span>
          <Icon width={13} height={13} name="email" className="icon" />
        </span>
        <span className="icon-row-text">
          {email}
        </span>
      </div>
    )
  }

  renderJobTitle() {
    const { jobTitle } = this.props

    return jobTitle && (
      <div className="flex-row icon-row">
        <span>
          <Icon width={13} height={13} name="briefcase" className="icon" />
        </span>
        <span className="icon-row-text">
          {jobTitle}
        </span>
      </div>
    )
  }

  render() {
    const {
      endUser,
      conversationId,
      displayName,
    } = this.props

    return (
      <div className={style.profile}>
        <div className="flex-row header">
          <div>
            <Link to={`/contacts/details/${endUser.id}`} target="_self">
              <EndUserAvatar endUser={endUser} className="endUserAvatar" />
            </Link>
          </div>
          <div>
            <Link to={`/contacts/details/${endUser.id}`} className="name" target="_self">
              {displayName}
            </Link>
            <div className="flex-row action-links">
              {this.renderSocialIcons()}
              <FollowButton endUser={endUser} />
              {ACCESS.hasGates('has_sequence_enroll_in_convo_view') && <EnrollButtonConvo endUser={endUser} />}
            </div>
          </div>
        </div>
        <LocalTime endUser={endUser} conversationId={conversationId} />
        {this.renderEmail()}
        {this.renderJobTitle()}
      </div>
    )
  }
}

export default compose(
  branch(props => !props.endUser, renderComponent(Loading)),
  mapProps(({ endUser, ...props }) => {
    return {
      endUser,
      email: endUser.email,
      displayName: getDisplayName(endUser) || 'Site Visitor',
      linkedInHandle: _.get(endUser, 'attributes.linkedin_handle') || _.get(endUser, 'socialProfile.linkedin.handle'),
      twitterHandle: _.get(endUser, 'attributes.twitter_handle') || _.get(endUser, 'socialProfile.twitter.handle'),
      jobTitle: _.get(endUser, 'attributes.employment_title') || _.get(endUser, 'socialProfile.employment.title'),
      ...props,
    }
  }),
)(Profile)



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Person/Profile/index.js